import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AdminAuthUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: 'admin' | 'staff';
}

interface AdminAuthState {
  admin: AdminAuthUser | null;
  setAdmin: (admin: AdminAuthUser | null) => void;
}

export const useAdminAuthStore = create<AdminAuthState>()(
  persist(
    (set) => ({
      admin: null,
      setAdmin: (admin) => set({ admin }),
    }),
    { name: 'orenyva-admin-auth' },
  ),
);
